import { SESSION_COOKIE_NAME, SESSION_COOKIE_MAX_AGE, AUTH_COOKIE_NAME } from './constants';

function generateSessionId(): string {
  return 'sess-' + Math.random().toString(36).substring(2) + Date.now();
}

export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()!.split(';').shift() || null;
  return null;
}

export function ensureSessionId(): string {
  let sessionId = getCookie(SESSION_COOKIE_NAME);
  if (!sessionId) {
    sessionId = generateSessionId();
    document.cookie = `${SESSION_COOKIE_NAME}=${sessionId}; path=/; max-age=${SESSION_COOKIE_MAX_AGE}`;
  }
  return sessionId;
}

export function getSessionId(): string | null {
  return getCookie(SESSION_COOKIE_NAME);
}

/**
 * Structure of the sb-auth-token cookie set by auth.hollaco.com
 */
export interface AuthTokenData {
  access_token: string;
  refresh_token: string;
  user: {
    id: string;
    email?: string;
  };
}

/**
 * Parse the sb-auth-token cookie set by auth.hollaco.com.
 * Returns null if cookie doesn't exist or is invalid.
 */
export function getAuthToken(): AuthTokenData | null {
  const rawValue = getCookie(AUTH_COOKIE_NAME);
  if (!rawValue) {
    return null;
  }

  try {
    const decoded = decodeURIComponent(rawValue);
    const parsed = JSON.parse(decoded);

    if (!parsed.access_token || !parsed.user?.id) {
      console.warn('[Auth] sb-auth-token missing required fields');
      return null;
    }

    return parsed as AuthTokenData;
  } catch (error) {
    console.error('[Auth] Failed to parse sb-auth-token:', error);
    return null;
  }
}
